<template>
	<main class="mx-auto max-w-screen-xl px-4 pb-10 sm:px-6">
		<section
			class="relative mx-auto mb-8 max-w-screen-md overflow-hidden rounded-3xl border border-white/10 bg-boxdark px-6 py-8 shadow-2xl sm:px-10 sm:py-10"
			aria-labelledby="artist-name">
			<div class="absolute -right-16 -top-20 h-56 w-56 rounded-full bg-primary/20 blur-3xl" aria-hidden="true">
			</div>
			<div class="absolute -bottom-24 -left-20 h-52 w-52 rounded-full bg-secondary/10 blur-3xl"
				aria-hidden="true"></div>

			<div class="relative flex flex-col gap-7 sm:flex-row sm:items-center sm:justify-between">
				<div>
					<p class="mb-2 text-xs font-bold uppercase tracking-[0.3em] text-secondary">Artiste tatoueur</p>
					<h2 id="artist-name" class="text-3xl font-bold tracking-tight text-white sm:text-4xl">René Domingue
					</h2>
					<p class="mt-2 text-bodydark2">Rendom Tattoo</p>
				</div>

				<div class="flex w-full flex-col gap-3 sm:w-auto">
					<a href="https://www.instagram.com/rendom_tattoo/" target="_blank" rel="noopener noreferrer"
						class="group flex items-center gap-3 rounded-xl bg-white px-5 py-3 font-bold text-black-2 transition hover:-translate-y-0.5 hover:bg-gray"
						aria-label="Voir le profil Instagram de Rendom Tattoo">
						<svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
							aria-hidden="true">
							<rect x="3" y="3" width="18" height="18" rx="5"></rect>
							<circle cx="12" cy="12" r="4"></circle>
							<circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"></circle>
						</svg>
						<span>@rendom_tattoo</span>
						<svg class="ml-auto h-4 w-4 transition group-hover:translate-x-1" viewBox="0 0 24 24"
							fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
							<path d="M5 12h14M13 6l6 6-6 6"></path>
						</svg>
					</a>

					<a href="tel:+15146510409"
						class="flex items-center gap-3 rounded-xl border border-white/15 bg-white/5 px-5 py-3 font-medium text-white transition hover:-translate-y-0.5 hover:border-secondary/60 hover:bg-white/10">
						<svg class="h-5 w-5 text-secondary" viewBox="0 0 24 24" fill="none" stroke="currentColor"
							stroke-width="2" aria-hidden="true">
							<path
								d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.33 1.78.62 2.63a2 2 0 0 1-.45 2.11L8 9.73a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.85.29 1.73.5 2.63.62A2 2 0 0 1 22 16.92z">
							</path>
						</svg>
						<span>514-651-0409</span>
					</a>

					<!-- Messenger -->
					<button type="button" @click="openMessenger" class="group flex items-center justify-center gap-3
				       px-5 py-4 rounded-2xl
				       bg-blue-600 text-white font-bold
				       shadow-lg shadow-blue-600/20
				       transition-all duration-300
				       hover:bg-blue-700 hover:-translate-y-1
				       hover:shadow-xl active:scale-95">
						<span class="flex items-center justify-center
					       w-9 h-9 rounded-full bg-white/20 text-lg">
							💬
						</span>

						<span>
							<span class="block text-xs font-medium opacity-80">
								Écris-moi sur
							</span>

							<span class="block">
								Messenger
							</span>
							<span class="block text-[10px] leading-[12px]">
								Rene.Domingue <br>
								(si ça n'a pas marché)
							</span>
						</span>
					</button>
				</div>
			</div>
		</section>

		<section class="flex flex-row items-center gap-4 mb-5" aria-label="Galerie Instagram">
			<div class="w-full max-w-screen-md mx-auto">
				<iframe src="https://cdn.lightwidget.com/widgets/e27015a4e91d528c967669cc1ce02e7b.html" scrolling="no"
					allowtransparency="true" class="lightwidget-widget" title="Publications Instagram de Rendom Tattoo"
					style="width:100%;border:0;overflow:hidden;"></iframe>
			</div>
		</section>
	</main>
</template>

<script setup>
import { onMounted } from 'vue'
onMounted(() => {
	const s = document.createElement('script')
	s.type = 'module'
	s.src = 'https://cdn.lightwidget.com/widgets/lightwidget.js'
	document.head.append(s)
})
const messengerUrl = 'https://m.me/rene.domingue/'

const openMessenger = () => {
	const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)

	// Sur mobile : tenter d'ouvrir directement l'application Messenger
	if (isMobile) {
		const messengerAppUrl = 'fb-messenger://user/rene.domingue'
		let fallbackTimer

		const cleanupFallback = () => {
			clearTimeout(fallbackTimer)
			window.removeEventListener('blur', cleanupFallback)
			window.removeEventListener('pagehide', cleanupFallback)
			document.removeEventListener('visibilitychange', handleVisibilityChange)
		}

		const handleVisibilityChange = () => {
			if (document.hidden) {
				cleanupFallback()
			}
		}

		window.addEventListener('blur', cleanupFallback)
		window.addEventListener('pagehide', cleanupFallback)
		document.addEventListener('visibilitychange', handleVisibilityChange)

		window.location.href = messengerAppUrl

		// Si le navigateur reste actif, Messenger n'a probablement pas pris le relais.
		fallbackTimer = setTimeout(() => {
			cleanupFallback()
			window.location.href = messengerUrl
		}, 1500)

		return
	}

	// Desktop
	window.open(
		messengerUrl,
		'_blank',
		'noopener,noreferrer'
	)
}
</script>
